import React from 'react'
import { SummaryLine } from '@mobi/betslip/Components/Common/SummaryLine'
import { StatusSilks } from '@core/Areas/Account/Pages/Activity/Components/Ticket/Components/StatusSilks'
import { shouldHideLegStatusSilks } from '@core/Areas/Account/Pages/Activity/Components/Ticket/Components/StatusSilks/helpers/shouldDisplayLegsStatusSilks'
import type { Ticket } from '@core/Areas/Account/Pages/Activity/types'

export const LegsStatusLine: React.FC<{ ticket: Ticket }> = ({ ticket }) => {
  if (shouldHideLegStatusSilks(ticket)) return null

  return <SummaryLine testId='StatusSilks' left='Legs' right={<StatusSilks ticket={ticket} />} />
}
